import { EventFormData } from '~admin/view/components/details/event-form-data';
import { buildFeeList } from '~admin/view/components/create-event/helper/event-profile-request/event-fee-details/build-fee-list.helper';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';

/**
 * Transforms EventFeeFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventFeeDetailsRequest = (
  values: EventFormData,
): Pick<EventProfileCreateRequest, 'feeRequestList'> => {
  const { marketplaces, currency, fees } = values;
  const feeList = buildFeeList(marketplaces, fees, currency);

  return {
    feeRequestList: feeList,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-fee-details-request.helper.ts